import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { forwardRef } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CustomDropdown = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var menuButtonEl = _ref.menuButtonEl,
      menuItemEl = _ref.menuItemEl,
      show = _ref.show,
      toggle = _ref.toggle,
      menuButtonLabelButton = _ref.menuButtonLabelButton,
      disabled = _ref.disabled;
  return /*#__PURE__*/_jsx(Menu, {
    as: "div",
    className: "relative",
    ref: ref,
    children: function children() {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [menuButtonEl ? /*#__PURE__*/_jsx(_StyledMenuButton, {
          disabled: disabled,
          onClick: function onClick(e) {
            e.preventDefault();
            if (toggle) toggle();
          },
          children: menuButtonEl
        }) : menuButtonLabelButton ? menuButtonLabelButton : null, /*#__PURE__*/_jsx(_StyledTransition, {
          show: show,
          enter: "transition duration-100 ease-out",
          enterFrom: "transform scale-95 opacity-0",
          enterTo: "transform scale-100 opacity-100",
          leave: "transition duration-300 ease-out",
          leaveFrom: "transform scale-100 opacity-100",
          leaveTo: "transform scale-95 opacity-0",
          children: /*#__PURE__*/_jsx(_StyledMenuItems, {
            children: menuItemEl ? /*#__PURE__*/_jsx(_StyledDiv, {
              children: menuItemEl
            }) : /*#__PURE__*/_jsx("em", {
              children: "no items"
            })
          })
        })]
      });
    }
  });
});

var _StyledMenuButton = /*#__PURE__*/_styled(Menu.Button).withConfig({
  displayName: "custom-dropdown___StyledMenuButton",
  componentId: "sc-f9dchr-0"
})({
  "position": "relative",
  "cursor": "pointer",
  "borderRadius": "0.375rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(249 250 251 / var(--tw-bg-opacity))",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))",
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(243 244 246 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(138 112 184 / var(--tw-text-opacity))"
  },
  ":focus": {
    "outline": "2px solid transparent",
    "outlineOffset": "2px",
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(255 255 255 / var(--tw-ring-opacity))",
    "--tw-ring-offset-width": "2px",
    "--tw-ring-offset-color": "#e2d8f3"
  },
  "@media (min-width: 1024px)": {
    "width": "100%",
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "whiteSpace": "nowrap",
    "backgroundColor": "transparent",
    "fontSize": "1rem",
    "lineHeight": "1.5rem"
  }
});

var _StyledTransition = /*#__PURE__*/_styled(Transition).withConfig({
  displayName: "custom-dropdown___StyledTransition",
  componentId: "sc-f9dchr-1"
})({
  "position": "relative",
  "zIndex": "10"
});

var _StyledMenuItems = /*#__PURE__*/_styled(Menu.Items).withConfig({
  displayName: "custom-dropdown___StyledMenuItems",
  componentId: "sc-f9dchr-2"
})({
  "position": "absolute",
  "right": "0px",
  "marginTop": "1rem",
  "width": "100%",
  "minWidth": "18rem",
  "maxWidth": "20rem",
  "> :not([hidden]) ~ :not([hidden])": {
    "--tw-divide-y-reverse": "0",
    "borderTopWidth": "calc(1px * calc(1 - var(--tw-divide-y-reverse)))",
    "borderBottomWidth": "calc(1px * var(--tw-divide-y-reverse))",
    "--tw-divide-opacity": "1",
    "borderColor": "rgb(243 244 246 / var(--tw-divide-opacity))"
  },
  "borderRadius": "0.375rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "padding": "1.5rem",
  "--tw-shadow": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  "--tw-shadow-colored": "0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
  "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
  "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
  "--tw-ring-opacity": "0.05",
  "--tw-ring-color": "rgb(28 19 39 / var(--tw-ring-opacity))",
  ":focus": {
    "outline": "2px solid transparent",
    "outlineOffset": "2px"
  }
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "custom-dropdown___StyledDiv",
  componentId: "sc-f9dchr-3"
})({
  "padding": "0.25rem"
});